import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: 'How does the swap process work?',
      answer: 'Simply list your item with photos and details, browse what others are offering, and propose a swap. Once both parties agree, you can chat to arrange a safe meetup location and complete the exchange.'
    },
    {
      question: 'Is it safe to meet strangers for swaps?',
      answer: 'Yes! We prioritize safety with user verification, trust scores, and ratings. We recommend meeting in public places during daylight hours. Our community guidelines and reporting system help maintain a safe environment.'
    },
    {
      question: 'Can I give items away without swapping?',
      answer: 'Absolutely! You can choose to give items away for free, swap only, or be open to both options. Many members love giving to those in need or supporting local charities through our platform.'
    },
    {
      question: 'How do you verify users?',
      answer: 'We use email verification, optional phone verification, and social media linking. Users build trust scores through successful swaps and positive ratings from other community members.'
    },
    {
      question: 'What items can I swap?',
      answer: 'Almost anything! Clothes, electronics, furniture, books, toys, home decor, and more. We prohibit illegal items, weapons, and anything that violates our community guidelines.'
    },
    {
      question: 'How does location-based matching work?',
      answer: 'Our system shows you items available in your area based on your city or zip code. You can adjust the distance radius to find swaps nearby or expand your search for specific items.'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600">
            Find answers to common questions about our platform
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="border-b border-gray-200 last:border-0">
              <button
                onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                className="w-full py-6 flex items-center justify-between text-left hover:bg-gray-50 transition-colors px-4 rounded-lg cursor-pointer"
              >
                <span className="text-lg font-bold text-gray-900 pr-8">{faq.question}</span>
                <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-2xl text-gray-600 flex-shrink-0`}></i>
              </button>
              {openIndex === index && (
                <div className="px-4 pb-6 text-gray-600 leading-relaxed">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
